var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"home-page-left"},[_c('div',{staticClass:"tools-options"},_vm._l((_vm.toolsData),function(item,index){return _c('div',{key:index,staticClass:"tools-item",style:({backgroundImage: 'url(' + item.imgSrc + ')'}),on:{"click":function($event){return _vm.selectTools(item)}}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }